import React, { Component } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom';
import '../FormatNumero/FormatCurrency';
import currencyFormatter from '../FormatNumero/FormatCurrency';
import Menu from '../menu/Menu';
import './ListaPedido.css';
import Cookies from 'universal-cookie';

export default class Usuario extends Component {
    
    state = {
        _Usuario: [],
        ckCPF: '',
    }

    async componentDidMount() {
        const cookies = new Cookies();
        this.state.ckCPF = cookies.get('ckCPF')
        console.log(this.state.ckCPF)
        const response = await api.get(`/datasnap/rest/tsm/recpedidos("${this.state.ckCPF}")`);
        this.setState({ _Usuario: response.data.result[0] });
        console.log(response.data.result[0]);
    }
    render() {
        return (
            <div className="principal">
                <div className="ListPed">
                    <Menu />
                    <p></p>
                    <h2>Lista de Pedidos</h2>
                    <table className="table table-hover table-striped table-dark">
                        <thead>
                            <tr>
                                {/* NUMTRANSVENDA":"1600272","CODFILIAL":"1","NUMPED":"2700045788","DATA":"28/06/2017","TOTAL":" 157.53"}, */}
                                <th scope="col">Filial</th>
                                <th scope="col">Nº Pedido</th>
                                <th scope="col">Data</th>
                                <th scope="col">Total R$</th>
                                <th scope="col">Itens ... </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state._Usuario.map(usuario => (
                                <tr key={usuario.NUMTRANSVENDA}>
                                    <th scope="row">{usuario.CODFILIAL}</th>
                                    <td>{usuario.NUMPED}</td>
                                    <td>{usuario.DATA}</td>
                                    <td>{currencyFormatter(parseFloat(usuario.TOTAL))}</td>
                                    <td><Link to={`/HOn/ListaItemPedido/"${usuario.NUMPED}"`}>Itens</Link></td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}